export default "__VITE_ASSET__Bd9j4khg__"